import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LayoutService } from '../navigation/layout.service';

@Injectable({ providedIn: 'root' })
export class MobileOnlyGuard implements CanActivate {
  private layout = inject(LayoutService);
  private router = inject(Router);


  canActivate(): boolean {
    if (this.layout.useMobileChrome()) {
      return true;
    }
    this.router.navigate(['/unemployment/recent-infos']);
    return false;
  }
}
